<template>
    <div class="o-notifications">
        <transition-group
            name="list"
            mode="in-out"
            tag="article"
        >
            <article
                class="o-notifications__notification"
                :class="`o-notifications__notification--${notification.type}`"
                v-for="(notification, id) in notifications"
                v-bind:key="`notification${id}`"
                @click="removeNotification(notification)"
            >
                <div
                    v-if="notification.title"
                    class="o-notifications__notificationHeader"
                >
                    <p>
                        {{ notification.title }}
                    </p>
                    <button
                        class="o-notifications__notificationClose"
                        aria-label="delete"
                        @click="removeNotification(notification)"
                    >
                        <a-icon icon="CloseDark" />
                    </button>
                </div>
                <div class="o-notifications__notificationBody">
                    {{ notification.content }}
                    <button
                        v-if="!notification.title"
                        class="o-notifications__notificationClose o-notifications__notificationClose--inBody"
                        aria-label="delete"
                        @click="removeNotification(notification)"
                    >
                        <a-icon icon="CloseDark" />
                    </button>
                </div>
            </article>
        </transition-group>
    </div>
</template>

<script>
export default {
    computed: {
        notifications() {
            return this.$store.getters.notifications
        }
    },
    methods: {
        removeNotification(notification) {
            this.$store.dispatch('removeNotification', notification.id)
        }
    }
}
</script>